<form #salesReturnForm="ngForm" class="form-container">
  <div class="form-header">
    <div class="form-breadcrumb">
      <h3><a [routerLink]="['/sales_return']">Sales Return</a> > {{ sales_return.sales_return_no }}</h3>
    </div>
    <div class="form-actions">
      <a *ngIf="sales_return.id && isFormDisabled && !['cancelled'].includes(sales_return.status)" target="_blank" href="/api/sales_return/{{ sales_return.id }}/download">
        <button type="button" mat-stroked-button><mat-icon>print</mat-icon> Print</button>
      </a>
      <ng-container *ngIf="!['submitted','cancelled'].includes(sales_return.status)">
        <button *ngIf="isFormDisabled && sales_return.status == 'draft'" type="button" mat-flat-button color="primary" (click)="confirmDialog()">
          <mat-icon>check_circle</mat-icon> Submit
        </button>
        <button *ngIf="!isFormDisabled" [disabled]="onSaveDisable" type="submit" mat-flat-button color="primary" (click)="save(salesReturnForm.valid)">
          <mat-icon>save</mat-icon> Save
        </button>
        <button *ngIf="isFormDisabled" type="button" mat-stroked-button (click)="edit()">
          <mat-icon>edit</mat-icon> Edit
        </button>
        <button *ngIf="isFormDisabled && sales_return.status == 'draft'" type="button" mat-stroked-button color="warn" (click)="cancelConfirmDialog()">Cancel</button>
        <button *ngIf="isFormDisabled" type="button" mat-flat-button color="primary" (click)="create()">
          <mat-icon>add</mat-icon> Create
        </button>
        <button *ngIf="!isFormDisabled" type="button" mat-stroked-button (click)="discardChanges()">Discard</button>
      </ng-container>
    </div>
  </div>
  <div class="form-card">
    <fieldset [disabled]="isFormDisabled">
      <div class="row">
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Sales Return No</mat-label>
            <input #sales_return_no="ngModel" [disabled]="true" type="text" matInput name="sales_return_no" [(ngModel)]="sales_return.sales_return_no">
            <mat-error *ngIf="sales_return_no.invalid && sales_return_no.touched">Required</mat-error>
          </mat-form-field>
        </div>
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Sales Return Date</mat-label>
            <input #date="ngModel" matInput [(ngModel)]="sales_return.sales_return_date" name="job_date" [matDatepicker]="sales_return_date" [min]="minDate" [max]="maxDate" required>
            <mat-datepicker-toggle matSuffix [for]="sales_return_date">
              <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
            </mat-datepicker-toggle>
            <mat-datepicker #sales_return_date></mat-datepicker>
            <mat-error *ngIf="date.invalid && date.touched">Required</mat-error>
          </mat-form-field>
        </div>
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Type</mat-label>
            <mat-select [(value)]="selectedSalesType" [disabled]="isFormDisabled || disableDoctorSelection" required autocomplete="off" (selectionChange)="onSalesTypeChange()">
              <mat-option *ngFor="let sales_ret_type of sales_ret_type" [value]="sales_ret_type.value">{{ sales_ret_type.viewValue }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Company</mat-label>
            <mat-select [disabled]="isFormDisabled || disableDoctorSelection" [(value)]="selectedCompany" (selectionChange)="onCompanyChange()">
              <input class="select-input" placeholder="Search..." type="text" autocomplete="nope" (keyup)="onCompanyKey($event)" matInput name="company_list">
              <mat-option *ngFor="let company of filteredCompanies" [value]="company.id">{{ company.company_name }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Doctor Name</mat-label>
            <mat-select #doctor_id (openedChange)="onDoctorScroll($event)" [disabled]="isFormDisabled || disableDoctorSelection" [(value)]="selectedDoctor" (selectionChange)="onDoctorChange()" required>
              <input class="select-input" placeholder="Search..." type="text" autocomplete="nope" (keydown)="$event.stopPropagation()" (keyup)="onDoctorKey($event)" matInput name="doctort_list">
              <mat-option *ngFor="let doctor of allDoctors" [value]="doctor.id">{{ doctor.name }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Account</mat-label>
            <mat-select #account_id (openedChange)="onAccountScroll($event)" [disabled]="isFormDisabled || disableDoctorSelection" [(value)]="selectedAccount" required>
              <input class="select-input" placeholder="Search..." type="text" autocomplete="nope" (keydown)="$event.stopPropagation()" (keyup)="onAccountKey($event)" matInput name="account_list">
              <mat-option *ngFor="let account of allAccounts" [value]="account.id">{{ account.name }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Select Invoice</mat-label>
            <mat-chip-grid class="matChipClasscross" #chipList aria-label="Invoice selection">
              <mat-chip-row class="matChipClass" *ngFor="let invoice of selectedInvoiceChips" [removable]="removable" (removed)="remove(invoice)">
                {{ invoice }}
                <button matChipRemove *ngIf="removable"><mat-icon>cancel</mat-icon></button>
              </mat-chip-row>
              <input #chipInput onkeydown="return false;" [formControl]="invoiceCtrl" [matAutocomplete]="auto" [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (matChipInputTokenEnd)="add($event)">
            </mat-chip-grid>
            <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
              <mat-option *ngFor="let invoice of notReturnedInvoices" [value]="invoice">{{ invoice.invoice_no }}</mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>
      </div>

      <!-- Line Items Table -->
      <table mat-table matSort [dataSource]="dataSource" #sales_lines class="mat-elevation-z2 mt-3">
        <ng-container matColumnDef="delete">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element; let i = index" class="cursor-pointer" (click)="deleteLine(i)"><i class="material-icons">delete</i></td>
        </ng-container>
        <ng-container matColumnDef="job_no">
          <th mat-header-cell *matHeaderCellDef>Job No.</th>
          <td mat-cell *matCellDef="let element">{{ element.job_no }}</td>
        </ng-container>
        <ng-container matColumnDef="product_name">
          <th mat-header-cell *matHeaderCellDef>Product Name</th>
          <td mat-cell *matCellDef="let element">{{ element.product_name }}</td>
        </ng-container>
        <ng-container matColumnDef="product_units">
          <th mat-header-cell *matHeaderCellDef>Unit</th>
          <td mat-cell *matCellDef="let element">{{ element.product_units }}</td>
        </ng-container>
        <ng-container matColumnDef="rate">
          <th mat-header-cell *matHeaderCellDef>Sales Rate</th>
          <td mat-cell *matCellDef="let element">{{ element.rate | currency :'INR':'symbol':'1.2-2' }}</td>
        </ng-container>
        <ng-container matColumnDef="change_rate">
          <th mat-header-cell *matHeaderCellDef>Change Rate</th>
          <td mat-cell *matCellDef="let element; let index = index">
            <input name="change_rate-{{index}}" [(ngModel)]="element.change_rate" (focusout)="calculateTaxesAndTotals(sales_return)" type="number" max="{{element.rate}}">
          </td>
        </ng-container>
        <ng-container matColumnDef="discount_percent">
          <th mat-header-cell *matHeaderCellDef>Discount (%)</th>
          <td mat-cell *matCellDef="let element">{{ element.discount_percent }}</td>
        </ng-container>
        <ng-container matColumnDef="amount_total">
          <th class="text-right" mat-header-cell *matHeaderCellDef>Amount</th>
          <td class="text-right" mat-cell *matCellDef="let element">{{ element.amount_total | currency :'INR':'symbol':'1.2-2' }}</td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

      <!-- Tax Totals -->
      <div class="row pt-4">
        <div class="col-sm-6"></div>
        <div class="col-sm-6">
          <div class="totals-card">
            <div class="totals-row"><span>Sub Total (&#8377;):</span><span>{{ sales_return.total_amount | currency :'INR':'symbol':'1.2-2' }}</span></div>
            <div class="totals-row"><span>Discount (&#8377;):</span><span>{{ sales_return.discount_amount | currency :'INR':'symbol':'1.2-2' }}</span></div>
            <div class="totals-row"><span>SGST (&#8377;):</span><span>{{ sales_return.sgst_amount | currency :'INR':'symbol':'1.2-2' }}</span></div>
            <div class="totals-row"><span>CGST (&#8377;):</span><span>{{ sales_return.cgst_amount | currency :'INR':'symbol':'1.2-2' }}</span></div>
            <div class="totals-row"><span>IGST (&#8377;):</span><span>{{ sales_return.igst_amount | currency :'INR':'symbol':'1.2-2' }}</span></div>
            <div class="totals-row totals-grand"><span>Grand Total (&#8377;):</span><span>{{ sales_return.grand_total | currency :'INR':'symbol':'1.2-2' }}</span></div>
            <div *ngIf="selectedSalesType == 'change_rate'" class="totals-row totals-grand"><span>Change Rate Difference (Incl. Tax) (&#8377;):</span><span>{{ sales_return.change_amount_total | currency :'INR':'symbol':'1.2-2' }}</span></div>
          </div>
        </div>
      </div>
    </fieldset>
  </div>
  <app-audit-log-viewer model="sales_return" [recordId]="sales_return.id"></app-audit-log-viewer>
</form>
